import { QueryClientProvider } from "@tanstack/react-query";
import { type ReactNode } from "react";
import { getQueryClient } from "@/lib/query-client";

// SPA-only — no Hydrate / HydrationBoundary needed (no SSR / RSC). DevTools
// rendered conditionally in main.tsx behind import.meta.env.DEV.
const client = getQueryClient();

export function QueryProvider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
